import { Banner } from '../banner/Banner';

const bannerContent = {
    header: 'Komplett reiseguide til VM',
    text: 'Trekningen er ferdig, og det er klart: Norge spiller gruppespillet på Østkysten!',
    callToAction: 'Se VM-guiden',
    link: 'https://www.finn.no/reise/artikler/norge-spiller-vm-pa-ostkysten-komplett-reiseguide-til-gruppespillet-2026',
    img: {
        src: 'https://finn-content-hub.imgix.net/bilder/GettyImages-1167392307_1.png?auto=format,compress&crop=focalpoint&fit=crop&fp-x=0.5&fp-y=1.5&w=470&h=300',
        width: 470,
        height: 300,
        alt: '',
    },
};

export const FrontpageBanner = () => {
    const { header, text, callToAction, link, img } = bannerContent;

    return <Banner header={header} text={text} callToAction={callToAction} link={link} imgType="img" img={img} />;
};
